import { Observable } from 'rxjs';
import type {
  TokenStats,
  TokenPlans,
  TokenAllData
} from '@coin-depo-types';

export interface TokenStatsFacade {
  cachedTokenStats$: Observable<TokenStats>;

  cachedTotalInterestPaid$: Observable<number>;
  cachedTotalAccruedInterest$: Observable<number>;
  cachedTotalAvailableBalance$: Observable<number>;
  cachedTotalBalance$: Observable<number>;

  cachedTokenPlans$: Observable<TokenPlans[]>;
  cachedAllTokensData$: Observable<TokenAllData[]>;

  cachedIsAccessTokens$?: Observable<boolean>;

  updateTokensStats(currency?: string): Observable<any>;

  getTokenPlansSnapshot(): TokenPlans[];
  getTokenStatsSnapshot(): TokenStats;
}